import { render, staticRenderFns } from "./competition-list.vue?vue&type=template&id=83674950&scoped=true"
import script from "./competition-list.vue?vue&type=script&lang=js"
export * from "./competition-list.vue?vue&type=script&lang=js"
import style0 from "./competition-list.vue?vue&type=style&index=0&id=83674950&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83674950",
  null
  
)

export default component.exports